const PROVINCE_DISTRICT_SEV_V2_LOCAL_STORAGE_KEY = 'province_district_sev_v2';
const PROVINCE_DISTRICT_CDN_URL = 'https://cdn.shopify.com/s/files/1/0650/1859/3459/files/province_district_sev_v2.json';

(function ($) {
  let province_district_sev = null;
  $(document).ready(function () {
    var router = new RouterRouter();
    //js ACCOUNT
    router.route('account/*type', function () {
      handleGetDistrict();
    })

    router.route('account/addresses', function () {
      handleEditAddress();
      handleAddNewAddress();

      setTimeout(function () {
        if ($('.remodal-is-opened').length > 0) {
          $('.remodal-is-opened').click();
        }

      }, 500);
    })

    /**
     * JS ACCOUNT ADDRESS -- add new address
     */
    function handleAddNewAddress() {
      $('[data-remodal-target="new-address"]').on('click', function () {
        const $frmAddress = $('#address_form_new');
        handleSetupForm($frmAddress);
        handleShowOptionDistrictNewAddress($frmAddress);
        handleShowOptionWardNewAddress($frmAddress);
      })
    }

    /**
     * JS ACCOUNT ADDRESS -- call API get district
     */
    function handleEditAddress() {
      // $('p.customer-address').map(function (i, ele) {
      //   $(ele).html($(ele).html().replace('00000', ''));
      // })
      const $eleAddressActions = $('.js-address-actions');
      $eleAddressActions.find('.link').on('click', function () {
        if ($(this).data('remodal-target') !== null) {
          const idEditAddress = $(this).data('remodal-target');
          const $frmAddress = $(`div[data-remodal-id="${idEditAddress}"]`).find('#form-address-validate');
          handleSetupForm($frmAddress);
          handleActiveProvince($frmAddress);
        }
      })
    }

    /**
     * JS ACCOUNT ADDRESS -- setup form
     */
    function handleSetupForm($frmAddress) {
      $frmAddress.find('[name="address[company]"]').parents('.form__control').hide();
      $frmAddress.find('[name="address[zip]"]').val('00000');
      $frmAddress.find('[name="address[zip]"]').parents('.form__control').hide();

      handleShowDistrict($frmAddress);
      handleShowCity($frmAddress);
      handleShowWard($frmAddress);
    }

    /**
     * JS ACCOUNT ADDRESS -- call API get district
     */
    function handleGetDistrict() {
      province_district_sev = JSON.parse(handleSession('get', PROVINCE_DISTRICT_SEV_V2_LOCAL_STORAGE_KEY));
      if (!province_district_sev) {
        getDistrict().then(data => {
          province_district_sev = data;
        })
      }
    }

    /**
     * JS CALL API GET DISTRICT
     */
    function getDistrict() {
      return new Promise((resolve, reject) => {
        $.get(PROVINCE_DISTRICT_CDN_URL, function (data) {
          resolve(data);
          handleSession('set', PROVINCE_DISTRICT_SEV_V2_LOCAL_STORAGE_KEY, JSON.stringify(data));
        })
      })
    }

    /**
     * JS get/set localStorage
     */
    function handleSession(type, key, val = null) {
      switch (type) {
        case 'set':
          sessionStorage.setItem(key, val);
          break;
        case 'get':
          return sessionStorage.getItem(key);
        default:
          break;
      }
    }

    /**
     * JS ACCOUNT ADDRESS -- show city
     */
    function handleShowCity(frmAddress) {
      if (frmAddress.find('select[name="address[city]"]').length === 0) {
        if (province_district_sev) {
          let xhtmlOption = '';
          province_district_sev.map(function (ele) {
            xhtmlOption += `<option value="${ele.name}" data-code="${ele.code}">${ele.name}</option>`;
          })
          let xhtml = `<div class="form__control" >
                      <label class="form__label float-label lb-select" for="address_city_3614547869832">City</label>
                      <div class="styled-select">
                        <svg class="icon icon-dropdown-arrow">
                          <use xlink:href="#icon-dropdown-arrow"></use>
                        </svg>
                        <select id="address_city_3614547869832" name="address[city]" required="" data-validate="required">
                          ${xhtmlOption}
                        </select>
                      </div>
                    </div>`;
          let eleTarget = frmAddress.find('[name="address[country]"]').parents('.form__control');
          $(xhtml).insertAfter(eleTarget);
          handleChangeCity();
        }
      }
    }

    /**
     * JS ACCOUNT ADDRESS -- show district
     */
    function handleShowDistrict(frmAddress) {
      if (frmAddress.find('select[name="address[province]"]').length === 0) {
        if (province_district_sev) {
          let xhtmlOption = '';
          let xhtml = `<div class="form__control" data-validate="required">
                      <label class="form__label float-label lb-select" for="address_province_3614547869832">District</label>
                      <div class="styled-select">
                        <svg class="icon icon-dropdown-arrow">
                          <use xlink:href="#icon-dropdown-arrow"></use>
                        </svg>
                        <select id="address_province_3614547869832" name="address[province]" required="">
                          ${xhtmlOption}
                        </select>
                      </div>
                    </div>`;
          let eleTarget = frmAddress.find('[name="address[country]"]').parents('.form__control');
          $(xhtml).insertAfter(eleTarget);
          handleChangeProvince();
        }
      } else {
        frmAddress.find('select[name="address[province]"]').parents('.form__control').show();
        handleChangeProvince();
      }
    }

    /**
     * JS ACCOUNT ADDRESS -- show ward
     */
    function handleShowWard (frmAddress) {
      if (frmAddress.find('select[name="address[ward]"]').length === 0) {
        if (province_district_sev) {
          let xhtmlOption = '';
          let xhtml = `<div class='form__control' data-validate='required'>
                      <label class='form__label float-label lb-select' for='address_ward_3614547869832'>Ward</label>
                      <div class='styled-select'>
                        <svg class='icon icon-dropdown-arrow'>
                          <use xlink:href='#icon-dropdown-arrow'></use>
                        </svg>
                        <select id='address_ward_3614547869832' name='address[ward]' required=''>
                          ${xhtmlOption}
                        </select>
                      </div>
                    </div>`;
          let eleTarget = frmAddress.find('[name="address[ward]"]').parents('.form__control');
          $(xhtml).insertAfter(eleTarget);
        }
      } else {
        frmAddress.find('select[name="address[ward]"]').parents('.form__control').show();
      }
    }

    /**
     * JS ACCOUNT ADDRESS -- on change select city
     */
    function handleChangeCity() {
      $('[name="address[city]"]').on('change', function () {
        handleShowOptionDistrict(this);
      })
    }

    /**
     * JS ACCOUNT ADDRESS -- on change select province
     */
    function handleChangeProvince () {
      $('[name="address[province]"]').on('change', function () {
        handleShowOptionWard(this);
      });
    }

    /**
     * JS ACCOUNT ADDRESS -- show option district
     */
    function handleShowOptionDistrict(ele) {
      const $frmAddress = $(ele).parents('form');
      const city_code = $frmAddress.find('[name="address[city]"] option:selected').data('code');
      const objProvince = handleGetObjProvince(city_code);

      if(!objProvince.length) return;

      let xhtmlOption = '';
      objProvince[0]['districts'].map(function (obj) {
        xhtmlOption += `<option value="${obj.code}" data-code="${obj.code}">${obj.name}</option>`;
      })
      $frmAddress.find('[name="address[province]"]').html(xhtmlOption);
      /** INFO: trigger change event to show ward */
      $('[name="address[province]"]').trigger('change');
    }

    /**
     * JS ACCOUNT ADDRESS -- show option ward
     */
    function handleShowOptionWard(ele) {
      const $frmAddress = $(ele).parents('form');
      const city_code = $frmAddress.find('[name="address[city]"] option:selected').data('code');
      const province_code = $frmAddress.find('[name="address[province]"] option:selected').data('code');
      const wardsList = handleGetObjWard(city_code, province_code);

      if (!wardsList.length) return;

      let xhtmlOption = '';
      wardsList.map(function (obj) {
        xhtmlOption +=
          `<option value='${obj.shippingProvider.code}' data-code='${obj.shippingProvider.code}'>${obj.shippingProvider.name}</option>`;
      });
      $frmAddress.find('[name="address[ward]"]').html(xhtmlOption);
    }

    /**
     * JS ACCOUNT ADDRESS -- show option district
     */
    function handleShowOptionDistrictNewAddress(frmAddress) {
      const city_code = frmAddress.find('[name="address[city]"] option:selected').data('code');
      const objProvince = handleGetObjProvince(city_code);
      let xhtmlOption = '';
      objProvince[0]['districts'].map(function (obj) {
        xhtmlOption += `<option value="${obj.code}" data-code="${obj.code}">${obj.name}</option>`;
      })
      frmAddress.find('[name="address[province]"]').html(xhtmlOption);
    }

    /**
     * JS ACCOUNT ADDRESS -- show option ward
     */
    function handleShowOptionWardNewAddress (frmAddress) {
      const city_code = frmAddress.find('[name="address[city]"] option:selected').data('code');
      const province_code = frmAddress.find('[name="address[province]"] option:selected').data('code');
      const wardsList = handleGetObjWard(city_code, province_code);
      if (wardsList?.length) {
        let xhtmlOption = '';
        wardsList.map(function (obj) {
          xhtmlOption +=
            `<option value='${obj.shippingProvider.code}' data-code='${obj.shippingProvider.code}'>${obj.shippingProvider.name}</option>`;
        });
        frmAddress.find('[name="address[ward]"]').html(xhtmlOption);
      }
    }

    /**
     * JS ACCOUNT ADDRESS -- filter get obj province
     */
    function handleGetObjProvince(city_code) {
      if (province_district_sev) {
        return province_district_sev.filter(function (e) {
          return e.code === city_code;
        });
      }
    }

    /**
     * JS ACCOUNT ADDRESS -- filter get obj ward
     */
    function handleGetObjWard (city_code, province_code) {
      let wardsList = [];
      if (province_district_sev) {
        const citiesList = handleGetObjProvince(city_code);
        if (citiesList?.length) {
          const provincesList = citiesList[0]?.districts?.find((district) => district.code === province_code);
          if (provincesList?.wards?.length) wardsList = provincesList.wards;
        }
      }

      return wardsList;
    }

    /**
     * JS ACCOUNT ADDRESS -- active province
     */
    function handleActiveProvince(form) {
      const $eleFormData = form.find('.js-address-form-data');
      const cityName = $eleFormData.data('city');
      let cityCode = cityName.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d")
        .replace(/Đ/g, "D")
        .replaceAll(/\s/g, "")
        .toUpperCase();

      if(cityCode === 'HUE') {
        cityCode = 'TTHUE';
      }

      if(cityCode.includes("VUNGTAU") || cityCode.includes("BARIA")) {
        cityCode = 'BRVT';
      }

      if(cityCode.includes("DACLAK") || cityCode.includes("DACLAC")) {
        cityCode = 'DAKLAK';
      }

      if(cityCode === 'DACNONG') {
        cityCode = 'DAKNONG';
      }

      const $eleCity = form.find('[name="address[city]"]');
      const cityValue = $eleCity.find(`option[data-code=${cityCode}]`).val();
      $eleCity.val(cityValue);
      handleShowOptionDistrict($eleCity);

      const provinceValue = $eleFormData.data('province') || '';
      const [provinceCode, wardCode] = provinceValue.split('_');
      const $eleProvince = form.find('[name="address[province]"]');
      $eleProvince.val(provinceCode);
      handleShowOptionWard($eleProvince);

      if (wardCode) {
        const $eleWard = form.find('[name="address[ward]"]');
        $eleWard.val(wardCode);
        $eleWard.data({
          default: wardCode,
          'default-value': wardCode
        });
      }
    }
  })

}(jQuery));
